<template>
    <div class="outer-content blur foreground">
        <div class="inner-content">
            <div class="donate_player_box">

                <div class="donate-title" v-html="modalTitle"></div>

                <p class="donate_body" v-html="modalIntro"></p>
                <div class="donate_option_grid">

                    <template v-for="(player, playerId) of playerOptions">

                        <div class="donate_container" v-bind:key="'donateRowFor' + playerId">
                            <AvatarCircle :size="68" :sizeInner="45" :id="player" :isSelected="false" :showName="true"
                                :selectable="false" :isReserved="false" :showRibbon="true" class="avatar-circle">
                            </AvatarCircle>
                        </div>

                        <div v-for="(amount, amountId) of amountOptions"
                            v-bind:key="'donateAmount' + amountId + 'for' + player"
                            :class="getDonateButtonClass(amount, player)" @click="selectedDonation(amount, player)">${{
                                amount }}K
                        </div>

                    </template>

                </div>

                <div class="button-container">
                    <div class="button" :class="canConfirm ? 'confirm-button' : 'confirm-button-disabled'"
                        @click="$emit('on-donate', donateTo)" v-html="T('button_Confirm')"></div>

                    <!-- temporary until close button confirmed -->
                    <div v-html="T('button_nothanks')" class="button no-thanks-button" @click="$emit('onclose')"></div>
                </div>

            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import AvatarCircle from "./AvatarCircle.vue";
import Game from '../../../shared_fca/game';
import playerState from '../../../shared_fca/playerstate';
import { T } from '@/App.vue';

export default Vue.extend({
    name: 'DonateBox',
    components: {
        AvatarCircle,
    },
    props: {
        game: Object as PropType<Game>,
        user: String,
    },
    data() {
        return {
            amountOptions: [50, 100, 200, 500],
            donateTo: {},
        }
    },
    computed: {

        modalTitle: {
            cache: false,
            get(): string {
                return T('Donate_modal_title');
            }
        },

        modalIntro: {
            cache: false,
            get(): string {
                return T('Donate_modal_intro');
            }
        },

        playerState: {
            cache: false,
            get(): playerState {
                return this.game.playerStates[this.user];
            }
        },

        playerOptions: {
            cache: false,
            get(): string[] {


                const result: string[] = [];
                for (const playerKey of Object.keys(this.game.playerStates)) {

                    const playerState = this.game.playerStates[playerKey];

                    //Don't allow donating to self
                    if (playerState == this.playerState) {
                        continue;
                    }

                    result.push(playerKey);
                }

                return result;

            }
        },
        canConfirm: {
            cache: false,
            get(): boolean {
                return Object.keys(this.donateTo).length > 0;
            }
        }
    },
    methods: {
        T(key: string): string {
            return T(key);
        },
        getDonateButtonClass(amount: number, playerId: string) {

            //We've selected to donate this amount to this player
            if (this.donateTo[playerId] == amount) {
                return "donate_BTN_selected";
            }

            //Add to the amount the amount we've already allocated to other players
            for (const otherPlayer of Object.keys(this.donateTo)) {
                if (otherPlayer == playerId) {
                    continue;
                }
                amount += this.donateTo[otherPlayer];
            }

            //Can't afford this donation
            if (amount > this.playerState.bankBalance) {
                return "donate_BTN_disabled";
            }

            return "donate_BTN";

        },

        selectedDonation(amount: number, playerId: string) {

            if (this.donateTo[playerId] == amount) {
                //cancel this donation
                this.$delete(this.donateTo, playerId);
            }
            else {
                //Set this donation
                this.$set(this.donateTo, playerId, amount);
            }

        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/*Donating to players*/
.donate_player_box {
    width: 759px;
    border-radius: 29px;
    background-color: #FFFFFF;
    position: absolute;
    top: 155px;
    left: 151px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.header-container {
    width: 100%;
    margin-top: 18px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.donate_icon {
    height: 40px;
    width: 40px;
}

.donate-title {
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
    font-size: 30px;
    font-weight: 800;
    line-height: 36px;
    margin-top: 27px;
}

.donate_close {
    height: 40px;
    width: 40px;
    position: absolute;
    top: 17px;
    left: 689px;
    cursor: pointer;
}

.donate_body {
    width: 500px;
    color: #636252;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
    margin-top: 33px;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

/*Donation character styling and grid layout*/
.donate_option_grid {
    display: grid;
    grid-template-columns: repeat(5, 128px);
    margin-top: 12px;
}

.donate_container {
    height: 80px;
    width: 68px;
    border-radius: 100%;
    margin-left: 10px;
}

.donate_character_pic {
    height: 50px;
    margin-top: 8px;
    margin-left: 14px;
}

.donate_BTN {
    height: 40px;
    width: 110px;
    border-radius: 8px;
    border-style: none;
    background-color: #DEDEC7;
    color: #636252;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    text-align: center;
    margin-top: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.donate_BTN_disabled {
    .donate_BTN;
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
}

.donate_BTN_selected {
    .donate_BTN;
    background-color: #636252;
    color: #FFFFFF;
}

.button-container {
    width: 100%;
    margin-bottom: 29px;
    margin-top: 23px;
    display: flex;
    justify-content: center;
}

.button-container .button {
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.button {
    margin-left: 10px;
    margin-right: 10px;
}

.no-thanks-button {
    background-color: #F1A738;
}
</style>